// Rodapé «powered by ImoDesk» com o símbolo.
export function PoweredBy({ className = "", testid = "powered-by" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] text-slate-400 ${className}`} data-testid={testid}>
      powered by <img src="/brand/imodesk-simbolo.svg" alt="" className="h-3.5 w-3.5" /> <span className="font-semibold text-slate-500">ImoDesk</span>
    </span>
  );
}
